import { decamelizeKeys } from "nvent-web/utils/decamelizeKeys";

import { type Accessory } from "nvent-web/types/Accessory";
import { type Product } from "nvent-web/types/Product";
import { type ProductCategory } from "nvent-web/types/ProductCategory";
import { type ProductSku } from "nvent-web/types/ProductSku";
import { type Thermostat } from "nvent-web/types/Thermostat";

import Resource from "./Resource";

export interface ProductCatalog {
  productCategories: ProductCategory[];
  products: Array<Product | Accessory | Thermostat>;
  productSkus: ProductSku[];
}

export default class ProductCatalogResource extends Resource {
  async getCatalog() {
    return this.http.get<ProductCatalog>("products/catalog");
  }

  async getCatalogForCountry(countryCode: string) {
    return this.http.get<ProductCatalog>("catalog", {
      params: decamelizeKeys({
        countryCode: countryCode.toUpperCase(),
      }),
    });
  }
}
